import { defineMessages, useIntl, FormattedDate } from 'react-intl';
import useCountdown from './useCountdown';

const messages = defineMessages({
  defaultHeading: {
    id: 'countdown.default.heading',
    defaultMessage: 'Starts in',
  },
  days: {
    id: 'countdown.days',
    defaultMessage: 'Days',
  },
  hours: {
    id: 'countdown.hours',
    defaultMessage: 'Hours',
  },
  minutes: {
    id: 'countdown.minutes',
    defaultMessage: 'Minutes',
  },
  seconds: {
    id: 'countdown.seconds',
    defaultMessage: 'Seconds',
  },
});

export type CountdownData = {
  heading?: string;
  targetDate?: string;
  daysLabel?: string;
  hoursLabel?: string;
  minutesLabel?: string;
  secondsLabel?: string;
};

/** Placeholder exibido antes de montar no cliente ou sem `targetDate`. */
const PLACEHOLDER = '--';

const pad2 = (value: number) => String(value).padStart(2, '0');

const CountdownView = ({ data }: { data: CountdownData }) => {
  const intl = useIntl();
  const countdown = useCountdown(data.targetDate);

  const groups = [
    {
      key: 'days',
      value: countdown ? String(countdown.days) : PLACEHOLDER,
      label: data.daysLabel || intl.formatMessage(messages.days),
    },
    {
      key: 'hours',
      value: countdown ? pad2(countdown.hours) : PLACEHOLDER,
      label: data.hoursLabel || intl.formatMessage(messages.hours),
    },
    {
      key: 'minutes',
      value: countdown ? pad2(countdown.minutes) : PLACEHOLDER,
      label: data.minutesLabel || intl.formatMessage(messages.minutes),
    },
    {
      key: 'seconds',
      value: countdown ? pad2(countdown.seconds) : PLACEHOLDER,
      label: data.secondsLabel || intl.formatMessage(messages.seconds),
    },
  ];

  return (
    <div className="block-countdown">
      <h2 className="countdown__heading">
        {data.heading || intl.formatMessage(messages.defaultHeading)}
      </h2>

      {/* Decorativo: atualiza a cada segundo, não deve ser lido pelo
          leitor de tela a cada tick. A data legível fica no irmão abaixo. */}
      <div className="countdown__groups" aria-hidden="true">
        {groups.map((group) => (
          <div className="countdown__group" key={group.key}>
            <span className="countdown__number">{group.value}</span>
            <span className="countdown__label">{group.label}</span>
          </div>
        ))}
      </div>

      {data.targetDate && (
        <p className="visually-hidden">
          <time dateTime={data.targetDate}>
            <FormattedDate
              value={data.targetDate}
              year="numeric"
              month="long"
              day="numeric"
              hour="numeric"
              minute="numeric"
            />
          </time>
        </p>
      )}
    </div>
  );
};

export default CountdownView;
